<template>
  <div class="messForm">
    <el-form ref="form" :model="form" :rules="rules" v-if="ifForm==1">
      <el-form-item prop="imageUrl" class="">
        <el-upload
          action="https://jsonplaceholder.typicode.com/posts/"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <div v-if="form.imageUrl" class="scoped-avatar-box">
            <img :src="form.imageUrl" class="scoped-avatar">
          </div>
          <label v-else class="scoped-box">
              <img class="scoped-icon" src="@/assets/imgs/memory/userCenter/head_portrait.png" alt="">
              <p class="scoped-tips">支持jpeg、jpg、png类型文件,大小不超过2M</p>
          </label>
        </el-upload>
        <template slot="error">
          <p class="scoped-err">请上传头像</p>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import myTitle from '@/common/title.vue'

export default {
  name: "messForm",
  props: ["ifForm", "isCall"],
  data() {
    return {
      rules: {
        imageUrl: [{ required: true, message: '请上传头像', trigger: 'blur' }],
      },
      form: {
        imageUrl: "",
      },
    };
  },
  components: {},
  watch: {
    isCall() {
      this.resetForm();
    }
  },
  methods: {
    resetForm() {// 清空
      this.imageUrl = "";
      if(this.$refs.form){
        this.$refs.form.resetFields();
      }
    },
    submit(callback){// 提交
      this.$refs.form.validate((valid) => {
        if (valid) {
          callback&&callback(this.form.imageUrl);
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    onSubmit() {
      // console.log(this.ifForm, "submit!");
    },
    handleAvatarSuccess(res, file) {
      this.form.imageUrl = URL.createObjectURL(file.raw);
      if(res.status >= 200 && res.status < 300){
        if(res.data && res.data.length){
          // this.form.imageUrl = res.data[0];//URL.createObjectURL(file.raw);
        }
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="less" scoped>
.messForm{
  margin:0 53px;
}
.scoped-box{
  margin:0 auto;
  width:425px;
  height:198px;
  background:#f1f1f1;
  border:1px solid #e2e2e2;
  display: block;
  text-align: center;
  cursor:pointer;
  width:320px;height:320px;
}
.scoped-avatar-box{
  border: 1px solid #ccc;
  text-align:center;
  line-height:320px;
  width:320px;height:320px;
}
.scoped-avatar{
  max-width: 320px;
  max-height: 320px;
  vertical-align:middle;
}
.scoped-icon{
  margin-top: 75px;
  margin-bottom: 15px;
  height:34px;
  vertical-align:middle;
  margin-top:120px;
  margin-bottom: 23px;
}
.scoped-tips{
  font-size:14px;
  line-height:14px;
  color:#999999;
}
.scoped-input{
  display:none;
}
.scoped-err{
  padding-top:10px;
  color:#F56C6C;
  font-size:12px;
  line-height:1;
  text-align:center;
}
</style>
<style lang="less">
.messForm {
  .mesUpload {
    .el-table__body {
      border-collapse: separate !important;
      border-spacing: 0px 5px !important;
    }
  }
}
</style>